/**
 * Registry API endpoint constants.
 * Evidence: docs/discovery/03-api-contracts-and-mappers.md — Endpoint Inventory
 * All paths are relative to the base URL (environment.api_base_url).
 */
export const REGISTRY_API = {
  auth: {
    exchangeCode: '/v1/auth/exchange-code',
    logout: '/v1/auth/logout',
  },
  users: {
    get: '/v1/users/get',
  },
  reports: {
    list: '/v1/reports/',
    create: '/v1/reports/',
    get: (id: string) => `/v1/reports/report/${id}`,
    getWithFiles: (id: string) => `/v1/reports/report-with-files/${id}`,
    update: (id: string) => `/v1/reports/${id}`,
    delete: (id: string) => `/v1/reports/${id}`,
    startAnalysis: '/v1/reports/start-analysis',
    startAnalysisExtension: '/v1/reports/start-analysis-extension',
    startAnalysisKaid: '/v1/reports/start-analysis-kaid',
    updateSectionsContent: (id: string) => `/v1/reports/${id}/update-sections-content-cache`,
    addUser: (id: string) => `/v1/reports/${id}/add-user`,
    deleteUser: (id: string, email: string) => `/v1/reports/${id}/delete-user/${email}`,
    getUsers: (id: string) => `/v1/reports/${id}/users`,
    getUploadUrl: '/v1/reports/get-upload-url',
    getDownloadUrl: '/v1/reports/get-download-url',
    checkCredits: '/v1/reports/check-credits',
    extractText: '/v1/reports/extract-text',
    consumptionHistory: '/v1/reports/consumption-history',
    downloadDebugFiles: (id: string) => `/v1/reports/${id}/download-debug-files`,
  },
  feedbacks: {
    list: '/v1/feedbacks/',
    create: '/v1/feedbacks/',
  },
  subscriptions: {
    base: '/v1/subscriptions',
  },
  notifications: {
    base: '/v1/notifications',
  },
  kbs: {
    base: '/v1/kbs',
  },
} as const;
